import React from 'react';
import PropTypes from 'prop-types';

class AccountPassword extends React.Component {
    constructor(props, context) {
        super(props, context);

        this.state = {};
    }

    static contextTypes = {
        user: PropTypes.object.isRequired,
    };

    render() {
        var user = this.context.user;
        return <div className="row account">Change password!!</div>;
    }
}

export default AccountPassword;



/** WEBPACK FOOTER **
 ** ../src/dash/front/components/account/AccountPassword.js
 **/